// Pairs can transiently lack last_sent_timestamp in the store (e.g. mid-broadcast
// pusher updates); treating those as epoch 0 keeps the comparator a total order so
// the list never scrambles (BOT-1336).
const pairTime = pair => {
  const time = new Date(pair.attributes.last_sent_timestamp || 0).getTime()
  return Number.isNaN(time) ? 0 : time
}

export const pairComparator = (sortBy, direction) => {
  const dir = direction === 'asc' ? 1 : -1
  if (sortBy === 'alphabetical') {
    return (a, b) => dir * (a.attributes.display_name || '').localeCompare(b.attributes.display_name || '')
  }
  return (a, b) => dir * (pairTime(a) - pairTime(b)) || dir * (Number(a.id) - Number(b.id))
}

// Before BOT-1336 the recent-activity comparator was inverted: a stored 'asc' was
// actually displaying newest-first. Rewrite it to 'desc' once so the visible order
// merchants are used to survives the fix.
export const migrateConversationSortDirection = storage => {
  if (storage.getItem('conversationSortDirectionMigrated')) return
  storage.setItem('conversationSortDirectionMigrated', 'yes')
  const sortBy = storage.getItem('conversationSortBy') || 'recent'
  if (sortBy === 'recent' && storage.getItem('conversationSortDirection') === 'asc') {
    storage.setItem('conversationSortDirection', 'desc')
  }
}
